import React, { Component } from 'react'
import AnchorLink from 'react-anchor-link-smooth-scroll'
import {Link} from 'react-router-dom'
import './style.css';

export default class MobileMenu extends Component {

    state = {
        isMenuShow: false,
        isOpen: false,
    }

    menuHandler = () => {
        this.setState({
            isMenuShow: !this.state.isMenuShow
        })
    }

    setIsOpen = () => {
        this.setState({
            isOpen: !this.state.isOpen
        })
    }


    render() {

        const { isMenuShow, isOpen } = this.state;

        return (
            <div>
                <div className={`mobileMenu ${isMenuShow ? 'show' : ''}`}>
                    {/* <div className="clox" onClick={this.menuHandler}>Close Me</div> */}
                    <div className="logo2">
                        <h2><AnchorLink href='#home' onClick={this.menuHandler}>Veronika & Marek</AnchorLink></h2>
                    </div>
                    <ul className="responsivemenu">
                        <li><AnchorLink href='#home' onClick={this.menuHandler}>Domov</AnchorLink></li>
                        <li><AnchorLink href='#couple' onClick={this.menuHandler}>O nás</AnchorLink></li>
                        <li><AnchorLink href='#story' onClick={this.menuHandler}>Náš Príbeh</AnchorLink></li>
                        <li><AnchorLink href='#event' onClick={this.menuHandler}>Svadba</AnchorLink></li>
                        <li><AnchorLink href='#gifts' onClick={this.menuHandler}>Dary</AnchorLink></li>
                        <li><AnchorLink href='#gallery' onClick={this.menuHandler}>Galéria</AnchorLink></li>
                        {/* <li><Link to='/blog'>Blog</Link></li>
                        <li><Link to='/Blog-details'>Blog Details</Link></li> */}
                    </ul>
                    
                </div>

                <div className="showmenu" onClick={this.menuHandler}><i className="fa fa-bars" aria-hidden="true"></i></div>         
            </div>
        )
    }
}
